module.exports = __webpack_public_path__ + "img/SouthwickMaleSpadefoot_Kubel_20220823.7665b90f.jpg";